import Cookies from 'js-cookie'

const state = {
  user: {
    isLoggedIn: false,
    authToken: null,
    username: null,
    subdomain: null,
    merchant: null
  }
}

const mutations = {
  updateUser(state, user) {
    state.user = user
  },
  setUser(state, user) {
    let domain = `.${process.env.VUE_APP_BASE_DOMAIN}`
    let secure = true
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      domain = window.location.hostname
      secure = false
    }
    if (user) {
      state.user = user
      Cookies.set('inquiry-user', JSON.stringify(user), { secure, domain, expires: 90 })
    } else {
      Cookies.remove('inquiry-user', { secure, domain })
    }
  },
  updateMerchant(state, merchant) {
    state.user.merchant = merchant

    // Sync to cookie
    let domain = `.${process.env.VUE_APP_BASE_DOMAIN}`
    let secure = true
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      domain = window.location.hostname
      secure = false
    }
    Cookies.set('inquiry-user', JSON.stringify(state.user), { secure, domain, expires: 90 })
  }
}

const getters = {
  getUser(state) {
    return state.user
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
